import React from "react";
import { Link } from "react-router-dom";

export default function Logo({ className = "", compact = false }) {
  return (
    <Link to="/" data-testid="logo-link" className={`inline-flex items-center gap-2.5 ${className}`}>
      <img
        src="/logo.png"
        alt="RecoversCrypto"
        className="h-9 w-9 object-contain shrink-0"
        loading="eager"
        width={36}
        height={36}
      />
      {!compact && (
        <span className="font-heading text-lg font-semibold tracking-tight text-white">
          Recovers<span className="text-gold">Crypto</span>
        </span>
      )}
    </Link>
  );
}
